<template>
  <div id="app">
    <header class="head">
      <a class="back tl" href="javascript:history.back(-1)">
        <i class="el-icon-arrow-left"></i>
      </a>
      <a href="javascript:;" class="tc">
        <small class="font_18 co_f">评价列表</small>
      </a>
    </header>
    <main>
              <div class="comment-view">
                            <ul class="rating_list_ul">
                                <li class="rating_list_li"><img src="http://test.fe.ptdev.cn/elm/elmlogo.jpeg" class="user_avatar">
                                    <section class="rating_list_details">
                                        <header>
                                            <section class="username_star">
                                                <p class="username">4*******b</p>
                                            </section> <time class="rated_at">2017-02-10</time>
                                            </header>
                                        <article>
                                            真心是不错的真心是不错的真心是不错的真心是不错的真心是不错的
                                        </article>    
                                    </section>
                                </li>
                                <li class="rating_list_li"><img src="http://test.fe.ptdev.cn/elm/elmlogo.jpeg" class="user_avatar">
                                    <section class="rating_list_details">
                                        <header>
                                            <section class="username_star">
                                                <p class="username">4*******b</p>
                                            </section> <time class="rated_at">2017-02-10</time></header>
                                            <article>
                                           专业水军
                                        </article>  
                                    </section>
                                </li>
                            </ul>
                        </div>
    </main>
  </div>
</template>

<script type="text/ecmascript-6">
  
  export default {
    data() {
      return {
       
      };
    },
    methods: {
      
    },
    //页面加载时候
    created() {
    
    }
  
  }
</script>
<style lang="scss" scoped>
.comment-view{
  background: #ffffff
}
</style>



// WEBPACK FOOTER //
// commentlist.vue?5cab0e72